export enum ApplyMoment {
    ON_INIT,
    ALL_TIME,
    ON_CHANGE
}